<template lang="pug">
  #adminsuper-challenge-settings
    WtTile(ancestor vertical)
      WtTile(parent :col="12")
        WtTile(child :col="4")
          WtLabel(
            isLabelElement
            text="Challenge Builder"
            :tooltip-text="builderTooltip"
          )
          .level
            .level-left
              .level-item
                WtButton(
                  is-router-link
                  :to="routeObj()"
                ) CREATE A CHALLENGE

</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";

export default {
  name: "AdminSuperChallengeSettings",

  components: { WtLabel, WtTile, WtTitle, WtButton },

  data() {
    return {
      builderTooltip: `This creates a program-wide challenge. NOTE: you may not create challenges when logged in to other programs.
      `
    };
  },

  methods: {
    routeObj(mode) {
      return {
        name: "AdminSuperChallengeCenterBuilder",
        params: { mode }
      };
    }
  }
};
</script>

<style lang="sass" scoped></style>
